export const API_ENDPOINTS = {
  LOGIN: '/login',
  GET_USER_DETAIL: 'web/v1/user/user-details', //Temp Login
  GET_CLIENT: 'web/v1/contractsearch/clients',
  GET_CUSTOMER_BY_CLIENT: 'web/v1/contractsearch/customers',
  // GET_CONTRACTS_BY_ID: 'SearchPage/contracts/search-by-contract',
  // GET_CONTRACTS_BY_POLICY: 'SearchPage/contracts/search-by-policy',
  // GET_CONTRACTS_BY_VIN: 'SearchPage/contracts/search-by-vin',
  GET_CONTRACT_RECENT_SEARCH: 'web/v1/contractsearch/recent-search-items',
  POST_CONTRACT_RECENT_SEARCH: 'web/v1/contractsearch/add-recent-search-item',
  //GET_EQUIPMENTS: '/web/v1/master/equipments',
  GET_EQUIPMENTS: 'web/v1/contract-details-page/equipmentCard',
  GET_CONTRACT_DETAILS: 'web/v1/contract-details-page/customer-details',
  GET_INSURANCE_DETAILS: 'web/v1/contract-details-page/InsuranceTimeline',
  GET_DEFICIENCY_DETAILS: '/web/v1/dashboard/deficiencies',
  GET_CONTRACTS_BY_ID: 'web/v1/contractsearch/by-contract',
  GET_CONTRACTS_BY_POLICY: 'web/v1/contractsearch/by-policy',
  GET_CONTRACTS_BY_VIN: 'web/v1/contractsearch/by-vin',
  GET_CONTRACTS_BY_CUSTOMER: 'web/v1/contract-details-page/allcontracts-by-customer',
  GET_NOTES_BY_CONTRACT: 'web/v1/contract-details-page/notes-by-contract',
  GET_POLICY_ATTACHMENTS: 'web/v1/filenetservice/filenet-attachment',
  GET_POLICY_BILLING_DETAILS: 'web/v1/contract-details-page/policyBilling',
};
